import React from "react";
import { Form } from "react-bootstrap";

const FormInputGroup = ({ input, meta, id, label, ...props }) => (
	<Form.Group controlId={id} style={{ marginBottom: 22 }}>
		{label && <Form.Label>{label}</Form.Label>}
		<Form.Control
			spellCheck={false}
			{...input}
			{...props}
			isInvalid={meta.touched && meta.error}
		/>
		{meta.touched && meta.error && (
			<div type="invalid" className="errorMessage">
				{meta.error}
			</div>
		)}
	</Form.Group>
);

export default FormInputGroup;
